import { render, staticRenderFns } from "./DraggableResizer.vue?vue&type=template&id=10ad40f5&scoped=true&"
import script from "./DraggableResizer.vue?vue&type=script&lang=js&"
export * from "./DraggableResizer.vue?vue&type=script&lang=js&"
import style0 from "./DraggableResizer.vue?vue&type=style&index=0&id=10ad40f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad40f5",
  null
  
)

export default component.exports